// extracted by mini-css-extract-plugin
export default {"indicator":"loadingModal_indicator__PjA8P","load":"loadingModal_load__TrJ2I"};